/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterReportState } from "./type";

const INITIAL_STATE: FilterReportState = {
  filters: {
    search: "",
    regional_email: "",
    regional_id: undefined,
    created_at: "",
    created_at_start: "",
    created_at_end: "",
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

type FilterKeys = keyof FilterReportState["filters"];

const filterCashBalanceRecordSlice = createSlice({
  name: "filters",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter<K extends FilterKeys>(
      state: FilterReportState,
      action: PayloadAction<{ key: K; value: FilterReportState["filters"][K] }>
    ) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state) {
      state.filters = INITIAL_STATE.filters;
    },
    setPagination(
      state,
      action: PayloadAction<{ page: number; perPage: number }>
    ) {
      state.filters.meta = action.payload;
    },
  },
});

export const { setFilter, resetFilters, setPagination } =
  filterCashBalanceRecordSlice.actions;
export default filterCashBalanceRecordSlice.reducer;
